import React, { useState, useEffect } from "react";
import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import {
  textError,
  percentageError,
} from "../../../../utils/validationMessage";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";
import {
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";

const CustomTableRow = ({
  label,
  fields,
  formData,
  handleInputChange,
  showTotal,
  placeholder,
  errors,
  disabled,
}) => (
  <TableRow
    sx={{
      height: "auto",
    }}
  >
    <TableCell>{label}</TableCell>
    {fields.map((field) => (
      <TableCell
        key={field}
        sx={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflow: "visible",
        }}
      >
        <TextField
          name={field}
          value={formData[field]}
          onChange={handleInputChange}
          disabled={disabled}
          size="small"
          placeholder={placeholder}
          InputProps={{ disableUnderline: true }}
          sx={{
            "& .MuiOutlinedInput-root": {
              padding: "8px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            width: "100%",
          }}
          error={!!errors[field]}
          multiline
          minRows={1}
        />
      </TableCell>
    ))}
    {showTotal && (
      <TableCell>
        {label === "R&D" && (
          <TextField
            disabled={disabled}
            name="rAndDImprovements"
            value={formData.rAndDImprovements}
            onChange={handleInputChange}
            placeholder="Type Here"
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              width: "100%",
            }}
            InputProps={{ disableUnderline: true }}
            multiline
            minRows={1}
          />
        )}
        {label === "Capex" && (
          <TextField
            disabled={disabled}
            name="capexImprovements"
            value={formData.capexImprovements}
            onChange={handleInputChange}
            placeholder="Type Here"
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              width: "100%",
            }}
            InputProps={{ disableUnderline: true }}
            multiline
            minRows={1}
          />
        )}
      </TableCell>
    )}
  </TableRow>
);

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    rAndCapexDoc: false,
    sustainableSourcingDoc: false,
    productReclaimProcessesDoc: false,
    eprApplicableWasteDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [formData1, setFormData1] = useState({});
  const [formData, setFormData] = useState({
    rAndDCurrent: "",
    rAndDPrevious: "",
    capexCurrent: "",
    capexPrevious: "",
    rAndDImprovements: "",
    capexImprovements: "",
    sustainableSourcing: "Yes",
    sustainablePercentage: "",
    plasticsProcess: "",
    eWasteProcess: "",
    hazardousProcess: "",
    otherWasteProcess: "",
    eprApplicable: "Yes",
    eprDetails: "",
  });

  const [errors, setErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const type = "SectionC";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/brsr/get?subType=principle2&type=${type}&id=${id}`,
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        if (
          response &&
          response.data &&
          response.data.data.BRSRSectionC &&
          response.data.data.BRSRSectionC.principle2.essentialIndicators
        ) {
          const essentialIndicators =
            response.data.data.BRSRSectionC.principle2.essentialIndicators;
          setFormData1(essentialIndicators);
          // Set the form data with the necessary values
          setFormData({
            rAndDCurrent: essentialIndicators.rAndD.currentFinancialYear ?? "",
            rAndDPrevious:
              essentialIndicators.rAndD.previousFinancialYear ?? "",
            capexCurrent:
              essentialIndicators.CapexInvestments.currentFinancialYear ?? "",
            capexPrevious:
              essentialIndicators.CapexInvestments.previousFinancialYear ?? "",
            rAndDImprovements:
              essentialIndicators.rAndD.detailsOfImprovements ?? "",
            capexImprovements:
              essentialIndicators.CapexInvestments.detailsOfImprovements ?? "",
            sustainableSourcing: essentialIndicators.sustainableSourcing.status
              ? "Yes"
              : "No",
            sustainablePercentage:
              essentialIndicators.sustainableSourcing.remark ?? "",
            plasticsProcess:
              essentialIndicators.productReclaimProcesses.plastics ?? "",
            eWasteProcess:
              essentialIndicators.productReclaimProcesses.eWaste ?? "",
            hazardousProcess:
              essentialIndicators.productReclaimProcesses.hazardousWaste ?? "",
            otherWasteProcess:
              essentialIndicators.productReclaimProcesses.otherWaste ?? "",
            eprApplicable: essentialIndicators.eprApplicable ? "Yes" : "No",
            eprDetails: essentialIndicators.eprWasteCollectionPlan.remark ?? "",
          });
        } else {
          console.error("Essential Indicators data is not available.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // setsnackOpen({
        //   open: true,
        //   message: "Failed to fetch data. Please try again.",
        //   severity: "error",
        // });
      }
    };

    fetchData();
  }, [id, type]);

  const handleChange = (field, value, name) => {
    if (field === "sustainablePercentage" && !validatePercentageInput(value))
      return;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.capexImprovements)
      newErrors.capexImprovements = "improvements  required.";
    if (!formData.rAndDImprovements)
      newErrors.rAndDImprovements = "improvements required.";

    const percentageFields = [
      "rAndDCurrent",
      "rAndDPrevious",
      "capexCurrent",
      "capexPrevious",
    ];

    percentageFields.forEach((field) => {
      const value = parseFloat(formData[field]);

      if (!formData[field]) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} required.`;
      } else if (isNaN(value)) {
        newErrors[field] = ` ${field.replace(
          /([A-Z])/g,
          " $1",
        )}Percentage must be a valid number.`;
      } else if (value < 0 || value > 100) {
        newErrors[field] = `${field.replace(
          /([A-Z])/g,
          " $1",
        )} Percentage must be between 0 and 100.`;
      }
    });

    if (formData.sustainableSourcing === "Yes") {
      // Check if sustainablePercentage is provided and is a number
      const sustainablePercentageValue = parseFloat(
        formData.sustainablePercentage,
      );
      if (
        !formData.sustainablePercentage ||
        isNaN(sustainablePercentageValue)
      ) {
        newErrors.sustainablePercentage = percentageError;
      } else if (
        sustainablePercentageValue < 0 ||
        sustainablePercentageValue > 100
      ) {
        newErrors.sustainablePercentage = percentageError;
      }
    }

    if (formData.eprApplicable === "Yes" && !formData.eprDetails) {
      newErrors.eprDetails = textError;
    }

    if (!formData.plasticsProcess) newErrors.plasticsProcess = textError;
    if (!formData.eWasteProcess) newErrors.eWasteProcess = textError;
    if (!formData.hazardousProcess) newErrors.hazardousProcess = textError;
    if (!formData.otherWasteProcess) newErrors.otherWasteProcess = textError;
    // if (!formData.eprDetails) newErrors.eprDetails = textError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!disabled) {
      if (!validateForm()) {
        return;
      }

      const payload = {
        essentialIndicators: {
          // ...formData,
          ...formData1,
          rAndD: {
            currentFinancialYear: formData.rAndDCurrent,
            previousFinancialYear: formData.rAndDPrevious,
            detailsOfImprovements: formData.rAndDImprovements,
          },
          CapexInvestments: {
            currentFinancialYear: formData.capexCurrent,
            previousFinancialYear: formData.capexPrevious,
            detailsOfImprovements: formData.capexImprovements,
          },
          sustainableSourcing: {
            status: formData.sustainableSourcing === "Yes",
            remark:
              formData.sustainableSourcing === "Yes"
                ? formData.sustainablePercentage
                : "",
          },
          productReclaimProcesses: {
            plastics: formData.plasticsProcess,
            eWaste: formData.eWasteProcess,
            hazardousWaste: formData.hazardousProcess,
            otherWaste: formData.otherWasteProcess,
          },
          eprApplicable: formData.eprApplicable === "Yes",
          eprWasteCollectionPlan: {
            status: formData.eprApplicable === "Yes",
            remark: formData.eprApplicable === "Yes" ? formData.eprDetails : "",
          },
        },
        essentialIndicatorsSubmitted: true,
        type: "SectionC",
        subType: "principle2",
      };

      try {
        const response = await put(`/brsr/update?id=${id}`, payload);
        setsnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        if (onSave) onSave(response.data);
      } catch (error) {
        console.error(error);
        setsnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    } else onSave();
  };

  const errorMessages = Object.entries(errors)
    .filter(([field]) =>
      [
        "rAndDCurrent",
        "rAndDPrevious",
        "capexCurrent",
        "capexPrevious",
        "rAndDImprovements",
        "capexImprovements",
      ].includes(field),
    )
    .map(([field, error]) => error)
    .join("  ");

  return (
    <Box>
      <p className={style.subHeading}>I. ESSENTIAL INDICATOR</p>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          {/* R&D and Capex Fields */}
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              mb: 2,
              textIndent: "-1rem",
              paddingLeft: "0.8rem",
            }}
            gutterBottom
          >
            1. Percentage of R&D and capital expenditure (capex) investments in
            specific technologies to improve the environmental and social
            impacts of product and processes to total R&D and capex investments
            made by the entity, respectively.
          </Typography>
          <TableContainer component={Paper} sx={{ marginLeft: "0.8rem" }}>
            <Table
              sx={{
                "& .MuiTableCell-root": {
                  borderRight: "1px solid #e0e0e0",
                  padding: "0px 16px",
                },
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <TableHead>
                <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "12%",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "22%",
                    }}
                  >
                    Current Financial Year
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "22%",
                    }}
                  >
                    Previous Financial Year
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "44%",
                    }}
                  >
                    Details of improvements in environmental and social impacts
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <CustomTableRow
                  disabled={disabled}
                  label="R&D"
                  fields={["rAndDCurrent", "rAndDPrevious"]}
                  placeholder="%"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  showTotal
                  errors={errors}
                />
                <CustomTableRow
                  label="Capex"
                  disabled={disabled}
                  fields={["capexCurrent", "capexPrevious"]}
                  placeholder="%"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  showTotal
                  errors={errors}
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Typography
          color="error"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginLeft: "2.5rem",
          }}
        >
          {errorMessages}
        </Typography>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "rAndCapexDoc",
            removeUpload,
            ml: "-0.2rem",
          }}
        />

        {/* Sustainable Sourcing */}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              textIndent: "-1rem",
              paddingLeft: "0.8rem",
            }}
            gutterBottom
          >
            2. a. Does the entity have procedures in place for sustainable
            sourcing?
          </Typography>
          <RadioGroup
            row
            disabled={disabled}
            value={formData.sustainableSourcing}
            onChange={(e) =>
              handleChange("sustainableSourcing", e.target.value)
            }
            sx={{ marginLeft: "0.8rem" }}
          >
            <FormControlLabel
              value="Yes"
              control={<Radio disabled={disabled} />}
              label="Yes"
            />
            <FormControlLabel
              value="No"
              control={<Radio disabled={disabled} />}
              label="No"
            />
          </RadioGroup>
        </Grid>
        {formData.sustainableSourcing === "Yes" && (
          <Grid item xs={8}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                textIndent: "-1rem",
                paddingLeft: "0.8rem",
              }}
              gutterBottom
            >
              2. b. If yes, what percentage of inputs were sourced sustainably?
            </Typography>
            <Grid item xs={10}>
              <TextField
                name="sustainablePercentage"
                disabled={disabled}
                value={formData.sustainablePercentage}
                onChange={(e) =>
                  handleChange("sustainablePercentage", e.target.value)
                }
                sx={{ marginLeft: "0.8rem" }}
                fullWidth
                size="small"
                placeholder="Enter %"
                error={!!errors.sustainablePercentage}
                helperText={
                  <Typography
                    variant="body2"
                    color="error"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                      marginLeft: "-1rem",
                    }}
                  >
                    {errors.sustainablePercentage || ""}
                  </Typography>
                }
              />
            </Grid>
            <BRSRFile
              {...{
                modalupload,
                setModalUpload,
                formData: formData1,
                setFormData: setFormData1,
                errors,
                setErrors,
                open,
                setOpen,
                Uploadkey: "sustainableSourcingDoc",
                ml: 1.5,
                removeUpload,
              }}
            />
          </Grid>
        )}

        {/* Processes */}
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              textIndent: "-1rem",
              paddingLeft: "0.8rem",
            }}
            gutterBottom
          >
            3. Describe the processes in place to safely reclaim your products
            for reusing, recycling and disposing at the end of life, for (a)
            Plastics (including packaging) (b) E-waste (c) Hazardous waste and
            (d) other waste.
          </Typography>
        </Grid>
        {[
          {
            field: "plasticsProcess",
            title: "a. Plastics (including packaging)",
            // subtitle: "Describe the processes",
          },
          {
            field: "eWasteProcess",
            title: "b. E-Waste",
            // subtitle: "Describe the processes",
          },
          {
            field: "hazardousProcess",
            title: "c. Hazardous Waste",
            // subtitle: "Hazardous waste ",
          },
          {
            field: "otherWasteProcess",
            title: "d. Other Waste",
            // subtitle: "Other Waste",
          },
        ].map(({ field, title, subtitle }, index) => (
          <Grid item xs={12} key={index} sx={{ marginLeft: "1rem" }}>
            {/* Title for each process */}
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#EB7E0E",
                marginBottom: 1,
              }}
            >
              {title}
            </Typography>

            {/* Subtitle */}
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "15px",
                color: "#000000",
                marginBottom: 1,
              }}
            >
              {subtitle}
            </Typography>

            {/* TextField for input */}
            <TextField
              name={field}
              disabled={disabled}
              value={formData[field]}
              onChange={(e) => handleChange(field, e.target.value)}
              fullWidth
              size="small"
              placeholder="Type"
              multiline
              rows={3}
              error={!!errors[field]}
              // helperText={errors[field]}
              helperText={
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-10px",
                  }}
                >
                  {errors[field]}
                </Typography>
              }
            />
          </Grid>
        ))}
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "productReclaimProcessesDoc",
            ml: 5,
            removeUpload,
          }}
        />

        {/* EPR */}
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              textIndent: "-1rem",
              paddingLeft: "0.8rem",
            }}
            gutterBottom
          >
            4. a. Whether Extended Producer Responsibility (EPR) is applicable
            to the entity's activities.
          </Typography>
          <RadioGroup
            row
            disabled={disabled}
            value={formData.eprApplicable}
            onChange={(e) => handleChange("eprApplicable", e.target.value)}
            sx={{ marginLeft: "0.8rem" }}
          >
            <FormControlLabel
              value={"Yes"}
              control={<Radio disabled={disabled} />}
              label="Yes"
            />
            <FormControlLabel
              value={"No"}
              control={<Radio disabled={disabled} />}
              label="No"
            />
          </RadioGroup>
        </Grid>
        {formData?.eprApplicable === "Yes" && (
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                textIndent: "-1rem",
                paddingLeft: "0.9rem",
              }}
              gutterBottom
            >
              4. b. If yes, whether the waste collection plan is in line with
              the Extended Producer Responsibility (EPR) plan submitted to
              Pollution Control Boards? If not, provide steps taken to address
              the same.
            </Typography>
            <TextField
              name="eprDetails"
              value={formData.eprDetails}
              onChange={(e) => handleChange("eprDetails", e.target.value)}
              fullWidth
              size="small"
              placeholder="Type"
              multiline
              rows={3}
              disabled={disabled}
              sx={{ marginLeft: "1rem", width: "98%" }}
              error={!!errors.eprDetails}
              helperText={
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-1rem",
                  }}
                >
                  {errors.eprDetails || ""}
                </Typography>
              }
            />
          </Grid>
        )}
      </Grid>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "eprApplicableWasteDoc",
          ml: 2,
          removeUpload,
        }}
      />

      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98%" }}>
              <ReviewBox url={`/brsr/review/${id}`} handleSubmit={handleSave} />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSave}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EssentialIndicator;
